export const API_BASE_URL = 'https://giripstechnologies.com';
export const WEB_BASE_URL = 'https://giripstechnologies.com/api/'
const getApiUrl = endpoint => API_BASE_URL + endpoint;

export const COUNRTY_DATA_WITH_CALLING_CODE = 'https://geolocation-db.com/json/'
export const CONTACT_US = getApiUrl('/api/contact');
export const WHATSAPP_UPDATE = getApiUrl('/api/whatsapp-updates');
export const NEWS_CATEGORIES = getApiUrl('/api/categories');
export const NEWS_POST = getApiUrl('/api/posts');

